{/* <html>

<head>
  <meta charset="utf-8" />
  <style>
    .pydocx-caps {
      text-transform: uppercase
    }

    .pydocx-center {
      text-align: center
    }

    .pydocx-comment {
      color: blue
    }

    .pydocx-delete {
      color: red;
      text-decoration: line-through
    }

    .pydocx-hidden {
      visibility: hidden
    }

    .pydocx-insert {
      color: green
    }

    .pydocx-left {
      text-align: left
    }

    .pydocx-list-style-type-cardinalText {
      list-style-type: decimal
    }

    .pydocx-list-style-type-decimal {
      list-style-type: decimal
    }

    .pydocx-list-style-type-decimalEnclosedCircle {
      list-style-type: decimal
    }

    .pydocx-list-style-type-decimalEnclosedFullstop {
      list-style-type: decimal
    }

    .pydocx-list-style-type-decimalEnclosedParen {
      list-style-type: decimal
    }

    .pydocx-list-style-type-decimalZero {
      list-style-type: decimal-leading-zero
    }

    .pydocx-list-style-type-lowerLetter {
      list-style-type: lower-alpha
    }

    .pydocx-list-style-type-lowerRoman {
      list-style-type: lower-roman
    }

    .pydocx-list-style-type-none {
      list-style-type: none
    }

    .pydocx-list-style-type-ordinalText {
      list-style-type: decimal
    }

    .pydocx-list-style-type-upperLetter {
      list-style-type: upper-alpha
    }

    .pydocx-list-style-type-upperRoman {
      list-style-type: upper-roman
    }

    .pydocx-right {
      text-align: right
    }

    .pydocx-small-caps {
      font-variant: small-caps
    }

    .pydocx-strike {
      text-decoration: line-through
    }

    .pydocx-tab {
      display: inline-block;
      width: 4em
    }

    .pydocx-underline {
      text-decoration: underline
    }

    body {
      margin: 0px auto;
      width: 51.00em
    }
  </style>
</head>

<body> */}

let privacyStEN = ` <style type="text/css">
p.p1 {
    margin: 0.0px 0.0px 0.0px 268.1px;
    line-height: 11.5px;
    font: 10.0px Helvetica;
    color: #000000
}

p.p2 {
    margin: 0.0px 0.0px 1.1px 72.0px;
    line-height: 12.0px;
    font: 12.0px Helvetica;
    color: #000000;
    min-height: 14.0px
}

p.p3 {
    margin: 0.0px 0.0px 0.0px 72.0px;
    text-align: justify;
    line-height: 12.0px;
    font: 10.0px Helvetica;
    color: #000000
}

p.p4 {
    margin: 0.0px 0.0px 0.9px 90.0px;
    line-height: 11.5px;
    font: 12.0px Helvetica;
    color: #000000;
    min-height: 14.0px
}

p.p5 {
    margin: 0.0px 0.0px 1.1px 90.0px;
    line-height: 11.5px;
    font: 10.0px Helvetica;
    color: #000000
}

p.p6 {
    margin: 0.0px 0.0px 1.9px 90.0px;
    line-height: 11.5px;
    font: 12.0px Helvetica;
    color: #000000;
    min-height: 14.0px
}

p.p7 {
    margin: 0.0px 0.0px 0.0px 90.0px;
    line-height: 11.5px;
    font: 10.0px Helvetica;
    color: #000000
}

p.p8 {
    margin: 0.0px 0.0px 0.0px 72.0px;
    text-align: justify;
    line-height: 12.3px;
    font: 10.0px Helvetica;
    color: #000000
}

p.p9 {
    margin: 0.0px 0.0px 0.0px 72.0px;
    line-height: 12.0px;
    font: 10.0px Helvetica;
    color: #000000
}

p.p10 {
    margin: 0.0px 0.0px 0.0px 72.0px;
    text-align: justify;
    line-height: 12.5px;
    font: 10.0px Helvetica;
    color: #000000
}

p.p11 {
    margin: 0.0px 0.0px 0.1px 72.0px;
    text-align: justify;
    line-height: 12.2px;
    font: 10.0px Helvetica;
    color: #000000
}

p.p12 {
    margin: 0.0px 0.0px 0.0px 72.0px;
    line-height: 10.9px;
    font: 10.0px Helvetica;
    color: #000000
}

p.p13 {
    margin: 0.0px 0.0px 11.8px 72.0px;
    text-align: justify;
    line-height: 12.4px;
    font: 10.0px Helvetica;
    color: #000000
}

p.p14 {
    margin: 0.0px 0.0px 0.5px 72.0px;
    text-align: justify;
    text-indent: 18.0px;
    line-height: 12.0px;
    font: 10.0px Helvetica;
    color: #000000
}

p.p15 {
    margin: 0.0px 0.0px 1.1px 72.0px;
    line-height: 11.5px;
    font: 10.0px Helvetica;
    color: #000000
}

p.p16 {
    margin: 0.0px 0.0px 0.5px 72.0px;
    text-align: justify;
    line-height: 12.0px;
    font: 10.0px Helvetica;
    color: #000000
}

p.p17 {
    margin: 0.0px 0.0px 0.0px 72.0px;
    line-height: 11.5px;
    font: 10.0px Helvetica;
    color: #000000
}

p.p18 {
    margin: 0.0px 0.0px 2.0px 90.0px;
    line-height: 11.5px;
    font: 12.0px Helvetica;
    color: #000000;
    min-height: 14.0px
}

p.p19 {
    margin: 0.0px 0.0px 0.1px 90.0px;
    line-height: 11.5px;
    font: 10.0px Helvetica;
    color: #000000
}

p.p20 {
    margin: 0.0px 0.0px 0.0px 0.0px;
    line-height: 12.0px;
    font: 11.0px Helvetica;
    color: #000000
}

p.p21 {
    margin: 0.0px 0.0px 0.0px 72.0px;
    line-height: 12.0px;
    font: 12.0px Helvetica;
    color: #000000;
    min-height: 14.0px
}

p.p22 {
    margin: 0.0px 0.0px 10.1px 72.0px;
    line-height: 12.0px;
    font: 12.0px Helvetica;
    color: #000000;
    min-height: 14.0px
}

p.p23 {
    margin: 0.0px 0.0px 0.0px 72.0px;
    text-align: justify;
    line-height: 12.2px;
    font: 10.0px Helvetica;
    color: #000000
}

p.p24 {
    margin: 0.0px 0.0px 0.0px 72.0px;
    line-height: 12.2px;
    font: 10.0px Helvetica;
    color: #000000
}

p.p25 {
    margin: 0.0px 0.0px 0.8px 90.0px;
    line-height: 11.5px;
    font: 12.0px Helvetica;
    color: #000000;
    min-height: 14.0px
}

p.p26 {
    margin: 0.0px 0.0px 1.5px 90.0px;
    line-height: 11.5px;
    font: 10.0px Helvetica;
    color: #000000
}

p.p27 {
    margin: 0.0px 0.0px 0.1px 72.0px;
    line-height: 11.5px;
    font: 10.0px Helvetica;
    color: #000000
}

p.p28 {
    margin: 0.0px 0.0px 1.4px 72.0px;
    text-align: justify;
    line-height: 12.0px;
    font: 10.0px Helvetica;
    color: #000000
}

p.p29 {
    margin: 0.0px 0.0px 0.5px 72.0px;
    line-height: 11.5px;
    font: 10.0px Helvetica;
    color: #000000
}

p.p30 {
    margin: 0.0px 0.0px 1.0px 90.0px;
    line-height: 11.5px;
    font: 12.0px Helvetica;
    color: #000000;
    min-height: 14.0px
}

p.p31 {
    margin: 0.0px 0.0px 0.0px 72.0px;
    text-align: justify;
    line-height: 13.0px;
    font: 10.0px Helvetica;
    color: #000000
}

p.p32 {
    margin: 0.0px 0.0px 0.0px 72.0px;
    line-height: 12.2px;
    font: 12.0px Helvetica;
    color: #000000;
    min-height: 14.0px
}

p.p33 {
    margin: 0.0px 0.0px 9.2px 72.0px;
    line-height: 12.2px;
    font: 12.0px Helvetica;
    color: #000000;
    min-height: 14.0px
}

p.p34 {
    margin: 0.0px 0.0px 1.7px 90.0px;
    line-height: 11.5px;
    font: 12.0px Helvetica;
    color: #000000;
    min-height: 14.0px
}

p.p35 {
    margin: 0.0px 0.0px 1.0px 90.0px;
    text-align: justify;
    line-height: 12.0px;
    font: 10.0px Helvetica;
    color: #000000
}

p.p36 {
    margin: 0.0px 0.0px 0.8px 90.0px;
    text-align: justify;
    line-height: 12.0px;
    font: 10.0px Helvetica;
    color: #000000
}

p.p37 {
    margin: 0.0px 0.0px 0.8px 90.0px;
    line-height: 12.2px;
    font: 10.0px Helvetica;
    color: #000000
}

p.p38 {
    margin: 0.0px 0.0px 0.0px 90.0px;
    line-height: 12.2px;
    font: 10.0px Helvetica;
    color: #000000
}

p.p39 {
    margin: 0.0px 0.0px 0.0px 90.0px;
    line-height: 11.5px;
    font: 12.0px Helvetica;
    color: #000000;
    min-height: 14.0px
}

p.p40 {
    margin: 0.0px 0.0px 0.9px 90.0px;
    line-height: 12.0px;
    font: 12.0px Helvetica;
    color: #000000;
    min-height: 14.0px
}

p.p41 {
    margin: 0.0px 0.0px 0.0px 90.0px;
    text-align: justify;
    line-height: 12.0px;
    font: 10.0px Helvetica;
    color: #000000
}

p.p42 {
    margin: 0.0px 0.0px 1.8px 90.0px;
    line-height: 11.5px;
    font: 12.0px Helvetica;
    color: #000000;
    min-height: 14.0px
}

p.p43 {
    margin: 0.0px 0.0px 0.6px 90.0px;
    line-height: 11.5px;
    font: 12.0px Helvetica;
    color: #000000;
    min-height: 14.0px
}

p.p44 {
    margin: 0.0px 0.0px 0.0px 72.0px;
    line-height: 11.5px;
    font: 10.0px Helvetica;
    color: #0b4bb4
}

p.p45 {
    margin: 0.0px 0.0px 11.9px 90.0px;
    line-height: 11.5px;
    font: 10.0px Helvetica;
    color: #000000
}

p.p46 {
    margin: 0.0px 0.0px 1.9px 72.0px;
    line-height: 11.5px;
    font: 12.0px Helvetica;
    color: #000000;
    min-height: 14.0px
}

p.p47 {
    margin: 0.0px 0.0px 0.1px 72.0px;
    line-height: 12.0px;
    font: 12.0px Helvetica;
    color: #000000;
    min-height: 14.0px
}

p.p48 {
    margin: 0.0px 0.0px 1.5px 72.0px;
    line-height: 11.5px;
    font: 10.0px Helvetica;
    color: #000000
}

p.p49 {
    margin: 0.0px 0.0px 11.0px 72.0px;
    text-align: justify;
    line-height: 12.3px;
    font: 10.0px Helvetica;
    color: #000000
}

p.p50 {
    margin: 0.0px 0.0px 0.8px 72.0px;
    line-height: 11.5px;
    font: 12.0px Helvetica;
    color: #000000;
    min-height: 14.0px
}

p.p51 {
    margin: 0.0px 0.0px 1.0px 72.0px;
    line-height: 11.5px;
    font: 12.0px Helvetica;
    color: #000000;
    min-height: 14.0px
}

p.p52 {
    margin: 0.0px 0.0px 11.2px 72.0px;
    text-align: justify;
    line-height: 12.0px;
    font: 10.0px Helvetica;
    color: #000000
}

p.p53 {
    margin: 0.0px 0.0px 0.8px 74.3px;
    line-height: 11.5px;
    font: 12.0px Helvetica;
    color: #000000;
    min-height: 14.0px
}

p.p54 {
    margin: 0.0px 0.0px 0.1px 74.3px;
    line-height: 11.5px;
    font: 10.0px Helvetica;
    color: #000000
}

span.s1 {
    letter-spacing: -0.1px
}

span.s2 {
    font: 10.0px 'Arial Unicode MS';
    letter-spacing: -0.1px
}

span.s3 {
    font: 10.0px Arial;
    letter-spacing: -0.1px
}

span.s4 {
    font: 10.0px 'Arial Unicode MS'
}

span.s5 {
    font: 10.0px Arial
}

span.s6 {
    letter-spacing: 0.1px
}

span.s7 {
    font: 10.0px 'Arial Unicode MS';
    letter-spacing: 0.1px
}

span.s8 {
    font: 10.0px Arial;
    letter-spacing: 0.1px
}

span.s9 {
    text-decoration: underline;
    color: #803b5e
}

span.s10 {
    color: #000000
}

span.s11 {
    text-decoration: underline;
    color: #0b4bb4
}

span.s12 {
    text-decoration: underline
}

span.s13 {
    font: 11.0px Helvetica;
    letter-spacing: -0.1px
}

span.s14 {
    font: 10.0px Helvetica;
    text-decoration: underline;
    letter-spacing: -0.1px;
    color: #803b5e
}

span.Apple-tab-span {
    white-space: pre
}
</style>
<p className="p1"><strong>Updated July 20, 2021</strong></p>
<p className="p1"><strong>Privacy Statement</strong></p>
<p className="p2"><br></p>
<p className="p3"><span className="s1">Barri, our subsidiaries and affiliates (&quot;Barri&quot; or &quot;we&quot; or &ldquo;us&rdquo;) care about your privacy and are committed to processing your personal information in accordance with fair information practices and applicable data protection laws to better serve you.</span></p>
<p className="p4"><br></p>
<p className="p5"><span className="s3">&nbsp;</span><span className="s1"><strong>SCOPE OF THIS PRIVACY STATEMENT</strong></span></p>
<p className="p3">This Privacy Statement describes how Barri collects, uses, stores, protects, discloses and shares your personal information or data when you use our Services online through our website, in retail and through our mobile app, as well as your choices about the way your information is collected and used. Personal information means all information or data relating to an identified or identifiable individual.</p>
<p className="p6"><br></p>
<p className="p7"><span className="s5">&nbsp;</span><strong>PERSONAL INFORMATION BARRI COLLECTS</strong></p>
<p className="p8"><span className="s1">When you use our services, contact us, access our websites or applications or join our VIP programs (collectively, the&nbsp;</span><span className="s6">&ldquo;Services&rdquo;), we collect personal information about you and may use it along with other information collected or&nbsp;</span><span className="s1">generated during our relationship with you. We collect different types of personal information relating to you, which may include:</span></p>
<p className="p9">Contact information, for example your name, postal address, e-mail address, telephone number, and date of birth, gender, citizenship, occupation, marital status, and government or national identification numbers; Transaction information, including your money transfers and bill payments;</p>
<p className="p10"><span className="s6">Business related information that helps us provide our Services to you, such as membership in our VIP programs,&nbsp;</span>how you use of our Services, bank and credit information, employer information and permissions to contact or marketing choices;</p>
<p className="p11">Technical information, including the host from which you access the Internet, your IP address or device advertising <span className="s1">ID, geolocation if enabled, information about your device (such as device properties, settings, applications, biometric&nbsp;</span>data (e.g., Touch ID/Fingerprint to verify your identity) storage and usage information), mobile application, browser and operating system software, social profile and network information, the date and time you access our websites and the address of the site from which you linked to our website when you visit us. We collect personal information on your online activities as described in the section titled &ldquo;<strong>INTERNET TECHNOLOGIES</strong>.&rdquo;</p>
<p className="p12">Compliance information, including fraud prevention, identity verification, and sanction checks.</p>
<p className="p13"><span className="s1">To conduct a money transfer, or use other payment services, you must provide certain information required by Barri&nbsp;</span><span className="s6">to execute the transfer and to enable us to comply with our legal obligations associated with transferring money.&nbsp;</span>Failure to provide some of your personal information may affect our ability to provide our Services to you. This may <span className="s6">include information about the form of identification used to send or receive a transaction (where required by law)&nbsp;</span><span className="s1">including the identification or a copy of the identification document, transaction activity, bank account and payment information.</span></p>
<p className="p14"><span className="s5">&nbsp;</span><strong>HOW BARRI COLLECTS PERSONAL INFORMATION&nbsp;</strong>Barri collects your personal information in several ways:</p>
<p className="p15">Through transaction forms and your interactions with Barri Agents and partners;</p>
<p className="p3">Through online forms, registrations for loyalty and rewards programs or competitions, and other online Services we offer (some of which may be managed by third parties on behalf of Barri);</p>
<p className="p16">While providing customer support or consultation, including using email, postal mail, call centers or live chat; Through the process of maintaining and upgrading our Services;</p>
<p className="p17">Through automated means such as communications protocols, e-mail communications and cookies or similar</p>
<p className="p18"><br></p>
<p className="p19"><span className="s3">&nbsp;</span><span className="s1"><strong>INTERNET TECHNOLOGIES;</strong></span></p>
<p className="p16">Through our mobile applications (some of which may be managed by third parties on behalf of Barri); Through your use of social media or other public data sources; and</p>
<p className="p15">Through your interest in Barri advertisements placed on third party sites.</p>
<p className="p3"><span className="s1">In addition to the personal information we collect from you, we may also collect your personal information from the person to whom you send and/or receive money, as well as our Agents, vendors, business partners, identity</span> verification companies, payments and fraud risk management companies, law enforcement bodies, and commercial and public data sources.</p>
<p className="p6"><br></p>
<p className="p7"><span className="s5">&nbsp;</span><strong>HOW BARRI SECURES YOUR PERSONAL INFORMATION</strong></p>
<p className="p23"><span className="s1">We endeavor to use organizational, technical and administrative safeguards that comply with applicable government&nbsp;</span><span className="s6">laws and regulations to secure your personal information. We also endeavor to restrict information access to our employees, Agents and representatives that need to know it. Despite our efforts, and as you probably know, third&nbsp;</span>parties may unlawfully intercept or access transmissions sent to us or may wrongly instruct you to disclose personal information to them while posing as Barri.</p>
<p className="p3">Please contact us immediately in accordance with the &ldquo;CONTACTING US&rdquo; section, if you have reason to believe your personal information held by Barri may be at risk.</p>
<p className="p6"><br></p>
<p className="p7"><span className="s3">&nbsp;</span><span className="s1"><strong>INTERNET TECHNOLOGIES</strong></span></p>
<p className="p24"><span className="s6">We use internet technologies like cookies, tags and web beacons on our websites, in mobile applications or when you visit a third-party website for which Barri provides online Services for a variety of purposes, including, but not limited to those identified in the section titled <strong>&ldquo;HOW BARRI USES THE PERSONAL INFORMATION IT COLLECTS&rdquo;</strong>. Barri has implemented the capability for the user to manage cookies on our websites. We will only read or write&nbsp;</span>cookies based on your preference level.</p>
<p className="p3">Do Not Track (DNT) is an optional browser setting that allows you to express your preferences regarding tracking by advertisers and other third-parties. We do not respond to DNT signals.</p>
<p className="p25"><br></p>
<p className="p26"><span className="s5">&nbsp;</span><strong>HOW BARRI USES THE PERSONAL INFORMATION IT COLLECTS</strong></p>
<p className="p27">Barri utilizes the personal information it collects for the following commercial purposes:</p>
<p className="p3"><strong>Performing the Services</strong>: To assist us in providing Services to you and help you to receive a personalized experience and assist you in carrying out transactions and accessing account information.;</p>
<p className="p28"><span className="s1"><strong>Authentication</strong>: To recognize you and allow you to remain signed-in during your visit without having to re-enter your password;</span></p>
<p className="p29"><strong>Analytics</strong>: To perform analytics on understanding our customers, improving their experience;</p>
<p className="p29"><strong>Web Traffic Analysis</strong>: To determine whether you came to Barri from a banner ad or an Affiliate;</p>
<p className="p27"><strong>Advertising</strong>: To deliver information specific to your interests on non-Barri websites and applications;</p>
<p className="p28"><span className="s6"><strong>Analysis of Promotions</strong>: To better understand the effectiveness of our promotional campaigns and whether you&nbsp;</span>acted on our promotional messages;</p>
<p className="p17"><strong>Fraud Prevention</strong>: To promote safety, reduce financial risk and combat fraud across our Services.</p>
<p className="p30"><br></p>
<p className="p7"><span className="s5">&nbsp;</span><strong>LEGAL BASES UPON WHICH WE USE YOUR PERSONAL INFORMATION</strong></p>
<p className="p31"><span className="s6">Barri may use your personal information as explained elsewhere in this Statement for each of the following legal&nbsp;</span>bases:</p>
<p className="p3"><span className="s1">We use your personal information to provide our services to you: This includes using personal information necessary&nbsp;</span>for conducting money transfers, payment services, prepaid cards, or VIP programs. We may use this information in the performance of a contract with you or for taking steps to enter into a contract for any of the above or for any other Barri products or services.</p>
<p className="p24"><span className="s6">We use your personal information for legitimate business purposes: This includes using personal information to&nbsp;</span>analyze and improve our products, locations, services, operations, the running of this site and your customer experience, and for measuring marketing return on investment and brand satisfaction. This may include using your <span className="s6">information to conduct market research surveys. We may also use your personal information to provide customer&nbsp;</span>services and to help protect the security and integrity of our technology, systems, and services. We use your personal information for legal and compliance purposes: This includes using personal information needed to comply with legal and regulatory duties related to anti-money laundering and counter-terrorist financing; detection, prevention and prosecution of fraud and theft as well as preventing illegitimate or prohibited use of our services or other illegal or wrongful activity. This may also include establishing, exercising, or defending legal rights and claims of Barri and others, and monitoring and reporting compliance issues. This may further include using your personal information to validate and authenticate your identity, and utilizing third parties to help us do so.</p>
We may process your personal information based on your consent as outlined in this Statement: This includes consent for receiving marketing communications, or where otherwise required by applicable law. If we request your consent, we will inform you of the intended purposes for which your information will be processed. We will inform you when your information is required to provide the services you request, or is required by law. In <span className="s1">certain cases, such as performing money transfer services, we may be unable to provide you with our Services unless you provide certain personal information.</span></p>
<p className="p4"><br></p>
<p className="p5"><span className="s5">&nbsp;</span><strong>HOW BARRI MARKETS TO ITS CUSTOMERS</strong></p>
<p className="p3">Barri will also, subject to your preferences, notify you of offers, promotions and updates regarding our products and Services. These may include offers by email, telephone, postal mail, SMS, social media and other communication or digital channels.</p>
<p className="p24"><span className="s6">You can opt out of receiving marketing communications at any time. If you no longer want to receive marketing-</span>related communications from us on a going-forward basis, you may opt-out by following the instructions in the relevant electronic communication or by contacting us as described in the &ldquo;CONTCT US&rdquo; section. Please note that if you opt-out of receiving marketing-related communications from us, we may still send you important service, administrative or transaction-related communications.</p>
<p className="p34"><br></p>
<p className="p19"><span className="s3">&nbsp;</span><span className="s1"><strong>INFORMATION FROM CHILDREN</strong></span></p>
<p className="p3"><span className="s6">Barri does not direct our Services or products at children under the age of 18. Barri does not knowingly collect or&nbsp;</span>maintain information from our retail, website or mobile apps from persons under the age of 18.</p>
<p className="p4"><br></p>
<p className="p5"><span className="s3">&nbsp;</span><span className="s1"><strong>EXTERNAL WEBSITES</strong></span></p>
<p className="p3"><span className="s6">Barri&rsquo;s Website may be linked to or from third party websites. Barri has not reviewed, does not control, and is not&nbsp;</span>responsible for the content or privacy practices employed by websites that are linked to or from our website. Barri does not assume responsibility for any of these sites, their content, or their privacy policies. Barri does not endorse <span className="s6">third party websites or make any warranties about any information, software or other products or materials you&nbsp;</span>may find there, or any results that may be obtained from using them.</p>
<p className="p6"><br></p>
<p className="p19"><span className="s5">&nbsp;</span><strong>WHO BARRI SHARES YOUR DATA WITH</strong></p>
<p className="p28"><span className="s6">For any of the purposes listed in this Statement, Barri may disclose applicable personal information including, but&nbsp;</span>not limited to, your name, contact information, national identification number, customer ID number, address, transaction patterns and bank account information to the following types of organizations or parties:</p>
<p className="p26"><span className="s7">&middot;</span><span className="s8"><span className="Apple-converted-space">&nbsp;</span></span><span className="s6">&nbsp;Barri group companies and affiliates;</span></p>
<p className="p5"><span className="s4">&middot;</span><span className="s5"><span className="Apple-converted-space">&nbsp;</span></span> Required local remittance licensing entities relevant to a transaction;</p>
<p className="p35"><span className="s4">&middot;</span><span className="s5"><span className="Apple-converted-space">&nbsp;</span></span> Our Agents or business partners who facilitate the money transfer transaction or specific service you have &nbsp; &nbsp; requested;</p>
<p className="p35"><span className="s7">&middot;</span><span className="s8"><span className="Apple-converted-space">&nbsp;</span></span><span className="s6">&nbsp;Vendors, payments processors, banking partners and data processors contracted to provide business and&nbsp;</span>&nbsp; &nbsp; customer services;</p>
<p className="p36"><span className="s4">&middot;</span><span className="s5"><span className="Apple-converted-space">&nbsp;</span></span> Customer services, based on your consent where applicable, including marketing, advertising and customer &nbsp; &nbsp; satisfaction and market research on our behalf;</p>
<p className="p37"><span className="s7">&middot;</span><span className="s8"><span className="Apple-converted-space">&nbsp;</span></span><span className="s6">&nbsp;Vendors and data processors contracted to help us validate the accuracy of the information provided by&nbsp;</span>&nbsp; &nbsp; you, and to authenticate your identity and manage risks related to security, fraud and identity. <span className="s4">&middot;</span><span className="s5"><span className="Apple-converted-space">&nbsp;</span></span> Third parties that you have authorized to access your account and/or your account information in order to &nbsp; &nbsp; perform Services for you, such as account information service providers and payment initiation service &nbsp; &nbsp; providers.</p>
<p className="p38"><span className="s4">&middot;</span><span className="s5"><span className="Apple-converted-space">&nbsp;</span></span> We may transmit personal information we possess in connection with a sale or transfer of all or part of our &nbsp; &nbsp; business. We may also disclose your personal information globally, as required or permitted by applicable &nbsp; &nbsp; <span className="s6">laws and regulations, to regulatory and financial authorities, credit reporting agencies, law enforcement&nbsp;</span>&nbsp; &nbsp; <span className="s1">bodies, courts, governments or government agencies, to meet compliance and legal obligations or to assert&nbsp;</span>&nbsp; &nbsp; <span className="s1">or defend the rights and interests of Barri or others.</span></p>

<p className="p7"><span className="s3">&nbsp;</span><span className="s1"><strong>INTERNATIONAL DATA TRANSFERS</strong></span></p>
<p className="p23"><span className="s6">We transfer your information to parties in countries outside the country it was collected, including but not limited&nbsp;</span>to<span className="Apple-converted-space">&nbsp; &nbsp;&nbsp;</span>the USA, as permitted or required by applicable law, regulatory authorities, law enforcement and government <span className="s6">agencies. Additionally, when you send or receive money to or from another country, we will also be required to share some of your personal information with that country as required or permitted by law. We transfer certain personal information about you to our data centers located in the USA or within a region as required by local law&nbsp;</span>and process<span className="Apple-converted-space">&nbsp; &nbsp;&nbsp;</span>it to fulfil our legal and compliance obligations which apply to our Services. We also store certain <span className="s6">personal information we collect based on your marketing choices in our US data center. By using Barri&rsquo;s Services,&nbsp;</span>you acknowledge that such transfers of information outside of your country of residence may occur.</p>
<p className="p25"><br></p>
<p className="p7"><span className="s5">&nbsp;</span><strong>RETENTION OF PERSONAL INFORMATION</strong></p>
<p className="p23">Your personal information will be retained in accordance with statutory periods contained in regulations applicable to financial transactions including those in anti-money laundering, anti-terrorist financing and other laws applicable to<span className="Apple-converted-space">&nbsp; &nbsp;&nbsp;</span>us. Otherwise, we will retain your information only if necessary for the specific purposes it was collected, or to <span className="s1">resolve any query you may raise. We will typically keep your information for no longer than the purpose(s) for which&nbsp;</span><span className="s6">it was obtained, unless we have a legal obligation to keep it for a longer period or retention is advisable for Barri&rsquo;s&nbsp;</span>legal position (for example, regarding applicable statutes of limitations, litigation or regulatory investigations).</p>
<p className="p40"><br></p>
<p className="p41"><span className="s5">&nbsp;</span><strong>ACCESSING, DELETING AND CORRECTING YOUR PERSONAL INFORMATION AND CHANGING YOUR &nbsp; &nbsp; CHOICES</strong></p>
<p className="p23">You have the right to know if we are processing your personal information and to ask us for a copy of your information free of charge. You have the right to request a structured and machine-readable copy of certain information you have provided to us. We may charge you a reasonable fee for providing the information, or not act upon your request, if the request is manifestly unfounded or excessive. You have the right to stop us from sending <span className="s6">you marketing communications. You have the right to ask us to correct information about you that is incomplete, inaccurate or out-of-date. You have the right to ask us to delete certain information about you, to restrict certain uses of information relating to you, and to object to certain uses of it. To the extent we are processing personal information based on your consent, you may withdraw your consent as permitted by applicable law. Registered&nbsp;</span>users may also visit barri.com and edit Profile settings. You also have the right to lodge a complaint with a relevant data protection regulator or supervisory authority about our processing of personal information. When we receive a request, we may ask for additional information from you to verify your identity. In some situations, we may refuse to act or may impose limitations on your rights, as permitted by applicable law. To exercise these rights, please contact Barri through the section titled &ldquo;<strong>CONTACT US</strong>&rdquo;. We will endeavor to respond to your request within 30 days <span className="s6">but response time may vary depending on the laws and regulations<span className="Apple-converted-space">&nbsp; &nbsp;&nbsp;</span>applicable to your request, and we may be&nbsp;</span>entitled to extend this period in certain circumstances. We will comply with your request to the extent required by applicable law.</p>
<p className="p42"><br></p>
<p className="p19"><span className="s3">&nbsp;</span><span className="s1"><strong>CONTACTING US</strong></span></p>
<p className="p28">If you have a question or complaint about how we handle your personal information, we ask that you put your inquiry in writing. We will investigate your inquiry and generally respond to you in writing within 30 days of receipt. You can also contact us at info@barri.com. (mailto: info@barri.com)</p>
<p className="p17">To contact us via a toll-free or local phone number, please follow this link to Contact Barri: <a href="https://www.barri.com/"><span className="s9">https://www.barri.com</span></a></p>
<p className="p30"><br></p>
<p className="p7"><span className="s3">&nbsp;</span><span className="s1"><strong>CHANGES</strong></span></p>
<p className="p10"><span className="s1">Barri reserves the right to modify this Privacy Statement. Updated privacy statements will be posted on this Website&nbsp;</span>when amendments occur. We urge you to review this Privacy Statement when you visit to obtain the most current statement.</p>
<p className="p43"><br></p>
<p className="p19"><span className="s5">&nbsp;</span><strong>USA CONSUMERS (INCLUDING CALIFORNIA RESIDENTS) PRIVACY NOTICE</strong></p>
<p className="p28">For consumers in the USA, (including those in California, Nevada, North Dakota, Texas and Vermont) please follow this link to Barri&rsquo;s Privacy Notice.</p>
<p className="p44"><span className="s10">( <a href="https://www.barri.com/bfgPrivacySt"><span className="s11">https://www.barri.com/bfgPrivacySt)</span></a></span></p>

<p className="p45"><span className="s5">&nbsp;</span><strong>California Consumer Privacy Act</strong></p>
<p className="p23"><span className="s1">Now that you know how we collect, use and share your personal information, the CCPA provides California residents&nbsp;</span><span className="s6">with specific rights regarding their personal information. This section describes your CCPA rights and explains how&nbsp;</span><span className="s1">to exercise those rights. In addition, the California Shine the Light law (CA Civ. Code &sect; 1798.83) requires us to provide&nbsp;</span>California residents with, upon their request, the names and addresses of third parties who have received personal <span className="s6">information and the categories of personal information shared. California residents have the right to request that&nbsp;</span>Barri Money Services discloses what personal information Barri Money Services has collected, used, disclosed, and <span className="s6">sold over the past 12 months. Once we receive and confirm your verifiable consumer request, we will disclose to you the necessary information in a portable and easily accessible format, normally within 45 days of request. You&nbsp;</span>may only make a verifiable consumer request for access or data portability twice in a 12-month period.</p>
<p className="p46"><br></p>
<p className="p17">When providing information under the right to know, we will include:</p>
<p className="p47"><br></p>
<p className="p16"><span className="s6">The categories of personal information the business collects about the consumer and has disclosed or sold for a&nbsp;</span>business purpose</p>
<p className="p48">The categories of sources of the consumer&rsquo;s personal information</p>
<p className="p27">The business or commercial purpose for collecting and selling the consumer&rsquo;s personal information</p>
<p className="p16">The categories of any third parties with whom the business shares the consumer&rsquo;s personal information or to whom personal information is sold</p>
<p className="p17">The specific pieces of personal information collected about the consumer</p>
<p className="p49">California residents also have the right to request the deletion of their personal data, subject to certain exceptions, and may not be discriminated against because they exercise their rights under the California Consumer Privacy Act. We may require you to provide additional personal data to verify your identity before we process your request; we may not process your request if we are unable to verify your identity.</p>
<p className="p31"><span className="s6">California residents also have the right to opt-out of the sale of personal information. In the preceding twelve (12)&nbsp;</span>months Barri Money Services has not sold any personal information.</p>
<p className="p50"><br></p>
<p className="p17">If you are a California resident and would like to make a request, please submit your request, in writing, to:</p>
<p className="p51"><br></p>
<p className="p15">Barri Money Services, LLC</p>
<p className="p16">10777 Westheimer Road, Suite 1040, Houston,TX 77042, USA.</p>
<p className="p29">1-800-926-2277</p>
<p className="p44"><span className="s12"><a href="http://www.barri.com/">http://www.barri.com</a></span><span className="s10">&nbsp;Or by email to <a href="mailto:info@barri.com"><span className="s11">info@barri.com</span></a></span></p>
<p className="p2"><br></p>
<p className="p52">You can also submit by these methods your questions or express concerns about Barri Money Services privacy policies and practices.</p>
<p className="p31">For California residents, please see the <a href="documents/CALIFORNIA_RESIDENT_ADDENDUM.pdf">California Resident Addendum</a> to this Privacy Statement </p>
<p className="p31">Accessing , deleting and correcting your personal information and changing your choices <a target="_blank" href="documents/CaliforniaConsumerRequest.pdf"><span className="s14">California Customer Request.</a></span></p>
<p className="p53"><br></p>
<p className="p54">Country</p>
<p className="p28">United States Language</p>
<p className="p28">Language</p>
<p className="p27">English</p>
<p className="p16">Send money, Pay bills, Prepaid cards </p>
<p className="p16">Follow us on</p>
<p className="p44"><span className="s12"><a href="https://facebook.com/Barrigroup/">Facebook</a></span></p>
<p className="p31">Services may be provided by Barri Money Services, LLC. NMLS# 937962 2021 Barri Money Services, LLC. All Rights Reserved</p>
</br>
<p>
<strong>DATA RETENTION</strong>
</br>
Barri retains only the data that is necessary to effectively conduct its activities, fulfill its mission and comply with applicable laws and regulations. Barri encrypt sensitive customer PII data in transit and in storage, and will rely on third parties to store card information and use tokenization to avoid storing sensitive card related information.
Barri will retain Customer PII and any card payment related data for a period of 5 years from the time of sale. When the retention period for the data expires, Barri will actively destroy the data covered by this policy.
</p>
`
{/* </body>

</html> */}
module.exports = privacyStEN;


// WEBPACK FOOTER //
// ./public/documents/privacy-statementEN-clover.js